export default {
    home: "Dom",
    order: {
        submit: "Przejrzyj zamówienie"
    },
    tunnel: {
        loginVerification: "Weryfikacja logowania",
        addressVerification: "Weryfikacja adresu"
    },
    catalog: "Katalog",
    all: "Wszystko",
    return: {
        return: "Powrót"
    },
    errors: {
        404: "@:views.errors.404.title"
    },
    impersonation: "Zamówienie w imieniu",
    approvals: "Zatwierdzenia",
    delegate: "Delegaci",
    employees: "Moi pracownicy",
}